import cloneDeep from 'lodash/cloneDeep'
import { useParseQueryParamsToSearchFilters } from '~/composables/useParseQueryParamsToSearchFilters'

export type CategoryTypes = string | number | boolean | undefined
export interface SearchFilterOptions {
  resetFilters?: boolean
  location?: string | undefined
  locationType?: string | undefined
  priceMin?: number
  priceMax?: number
  dates?: string[] | undefined
  tags?: string[] | undefined
  languages?: string[] | undefined
  categoriesBySlug?: string[] | undefined
  categories?: CategoryTypes[] | undefined
  hasAvailableDates?: boolean
  hasPromotion?: boolean
  query?: string | undefined
  typeOfClass?: string
  [name: string]: CategoryTypes | CategoryTypes[]
}

const getEmptyFilters = () => ({
  typeOfClass: undefined,
  hasAvailableDates: false,
  hasPromotion: false,
  location: undefined,
  categories: [],
  languages: [],
  priceMin: 0,
  priceMax: 1200,
  query: undefined,
})

export const useSearchFilters = (
  instance: string,
  defaultFilters:
    | ComputedRef<SearchFilterOptions | undefined>
    | Ref<SearchFilterOptions | undefined> = ref(undefined)
) => {
  const route = useRoute()
  const router = useRouter()
  const filters = useState<SearchFilterOptions>(`filters-${instance}`, () =>
    cloneDeep(getEmptyFilters())
  )

  // legacy category handling
  if (route.query.category) {
    const legacyCat = route.query.category?.toString().split(',')
    router.replace({
      query: {
        ...route.query,
        categories: legacyCat,
        category: undefined,
      },
    })
  }

  const { filters: filtersFromQueryParams } =
    useParseQueryParamsToSearchFilters(defaultFilters)

  watchEffect(() => {
    filters.value = filtersFromQueryParams.value
  })

  watch(
    () => route.query.query,
    () => {
      filters.value = filtersFromQueryParams.value
    }
  )

  const handleFiltersReset = () => {
    filters.value.categories = defaultFilters.value?.categories || []
    filters.value.location = defaultFilters.value?.location || undefined
  }

  return {
    filters,
    handleFiltersReset,
  }
}
